import React from 'react';
import Button from './Button';
import addUnsavedChangesWarnPreAction from '../hoc/addUnsavedChangesWarn';
import { logoutUser } from '../../redux/actions';
import LogOutIcon from '../../assets/images/logout.svg';

const LogoutButton = ({
  className = 'logout',
  onClick,
}) => (
  <Button
    title="Logout"
    onClick={onClick}
    className={className}
  >
    <img src={LogOutIcon} className="logout-icon" alt="" />
  </Button>
);

export default addUnsavedChangesWarnPreAction(LogoutButton, logoutUser);
